import React from 'react'
import {Icon} from 'src/common/Icon'

const AiSurgeChart: React.FC = () => (
  <section className="section white">
    <div className="wrap">
      <div className="subsection">
        <div className="sub-eyebrow">The AI surge · Jan 2024 → May 2026</div>
        <h3>
          From line item to 3rd-largest software
          <br />
          category in 28 months.
        </h3>
        <p className="sub-intro">
          Blue area: share of companies with AI spend (16% → 54%). Orange line: monthly AI spend in EUR (€44K → €1.99M).
          Dual-scale axis.
        </p>
        <div className="chart-card">
          <div className="chart-card-header">
            <div>AI adoption and spend</div>
            <Icon name="moss-logo-v2" className="chart-logo" />
          </div>
          <div className="chart-legend">
            <span>
              <span className="swatch area" />
              Share of companies with AI spend
            </span>
            <span>
              <span className="swatch line-orange" />
              Monthly AI spend (€)
            </span>
            <span className="chart-meta">29 months · dual y-axis</span>
          </div>
          <svg
            viewBox="0 0 1120 420"
            width="100%"
            height="auto"
            preserveAspectRatio="none"
            role="img"
            aria-label="AI adoption chart, January 2024 through May 2026"
          >
            <g stroke="rgba(19,18,18,0.06)" strokeWidth="1">
              <line x1="60" y1="50" x2="1060" y2="50" />
              <line x1="60" y1="130" x2="1060" y2="130" />
              <line x1="60" y1="210" x2="1060" y2="210" />
              <line x1="60" y1="290" x2="1060" y2="290" />
              <line x1="60" y1="370" x2="1060" y2="370" />
            </g>
            <g fontFamily="Systemia, sans-serif" fontSize="11" fill="#4A4A4A" textAnchor="end">
              <text x="52" y="54">
                60%
              </text>
              <text x="52" y="134">
                45%
              </text>
              <text x="52" y="214">
                30%
              </text>
              <text x="52" y="294">
                15%
              </text>
              <text x="52" y="374">
                0%
              </text>
            </g>
            <g fontFamily="Systemia, sans-serif" fontSize="11" fill="#C5500F" textAnchor="start">
              <text x="1068" y="54">
                €2.4M
              </text>
              <text x="1068" y="134">
                €1.8M
              </text>
              <text x="1068" y="214">
                €1.2M
              </text>
              <text x="1068" y="294">
                €600K
              </text>
              <text x="1068" y="374">
                €0
              </text>
            </g>
            <g fontFamily="Systemia, sans-serif" fontSize="11" fill="#4A4A4A" textAnchor="middle">
              <text x="60" y="395">
                Jan &apos;24
              </text>
              <text x="203" y="395">
                May &apos;24
              </text>
              <text x="346" y="395">
                Sep &apos;24
              </text>
              <text x="489" y="395">
                Jan &apos;25
              </text>
              <text x="631" y="395">
                May &apos;25
              </text>
              <text x="774" y="395">
                Sep &apos;25
              </text>
              <text x="917" y="395">
                Jan &apos;26
              </text>
              <text x="1060" y="395">
                May &apos;26
              </text>
            </g>
            {/* Blue area — AI adoption % */}
            <path
              d="M 60,284 L 96,279 L 131,275 L 167,278 L 203,215 L 239,175 L 274,176 L 310,175 L 346,168 L 381,162 L 417,158 L 453,154 L 489,151 L 524,149 L 560,139 L 596,137 L 631,128 L 667,130 L 703,131 L 739,125 L 774,124 L 810,125 L 846,122 L 881,114 L 917,112 L 953,103 L 989,96 L 1024,80 L 1060,81 L 1060,370 L 60,370 Z"
              fill="rgba(44,143,255,0.12)"
              stroke="none"
            />
            {/* Blue line — AI adoption % */}
            <path
              d="M 60,284 L 96,279 L 131,275 L 167,278 L 203,215 L 239,175 L 274,176 L 310,175 L 346,168 L 381,162 L 417,158 L 453,154 L 489,151 L 524,149 L 560,139 L 596,137 L 631,128 L 667,130 L 703,131 L 739,125 L 774,124 L 810,125 L 846,122 L 881,114 L 917,112 L 953,103 L 989,96 L 1024,80 L 1060,81"
              fill="none"
              stroke="rgba(44,143,255,0.85)"
              strokeWidth="1.5"
            />
            {/* Orange line — monthly AI spend */}
            <path
              d="M 60,364 L 96,364 L 131,360 L 167,359 L 203,351 L 239,351 L 274,352 L 310,353 L 346,349 L 381,347 L 417,345 L 453,347 L 489,322 L 524,332 L 560,319 L 596,323 L 631,321 L 667,316 L 703,309 L 739,306 L 774,306 L 810,286 L 846,283 L 881,261 L 917,244 L 953,234 L 989,175 L 1024,141 L 1060,105"
              fill="none"
              stroke="#FF8344"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {/* Callout 1 — Jun 2024, adoption line */}
            <circle cx="239" cy="175" r="6" fill="#131212" />
            <circle cx="239" cy="175" r="4" fill="#B4FF44" />
            <line x1="239" y1="175" x2="239" y2="115" stroke="#131212" strokeWidth="1" strokeDasharray="2 3" />
            <text
              x="239"
              y="109"
              fontFamily="Systemia, sans-serif"
              fontSize="11"
              fontWeight="700"
              fill="#131212"
              textAnchor="middle"
            >
              1
            </text>
            {/* Callout 2 — Jan 2025, spend line */}
            <circle cx="489" cy="322" r="6" fill="#131212" />
            <circle cx="489" cy="322" r="4" fill="#B4FF44" />
            <line x1="489" y1="322" x2="489" y2="250" stroke="#131212" strokeWidth="1" strokeDasharray="2 3" />
            <text
              x="489"
              y="244"
              fontFamily="Systemia, sans-serif"
              fontSize="11"
              fontWeight="700"
              fill="#131212"
              textAnchor="middle"
            >
              2
            </text>
            {/* Callout 3 — Feb 2026, spend line */}
            <circle cx="953" cy="234" r="6" fill="#131212" />
            <circle cx="953" cy="234" r="4" fill="#B4FF44" />
            <line x1="953" y1="234" x2="953" y2="160" stroke="#131212" strokeWidth="1" strokeDasharray="2 3" />
            <text
              x="953"
              y="154"
              fontFamily="Systemia, sans-serif"
              fontSize="11"
              fontWeight="700"
              fill="#131212"
              textAnchor="middle"
            >
              3
            </text>
            {/* Callout 4 — May 2026, spend line */}
            <circle cx="1060" cy="105" r="6" fill="#131212" />
            <circle cx="1060" cy="105" r="4" fill="#B4FF44" />
            <line x1="1060" y1="105" x2="1060" y2="75" stroke="#131212" strokeWidth="1" strokeDasharray="2 3" />
            <text
              x="1060"
              y="69"
              fontFamily="Systemia, sans-serif"
              fontSize="11"
              fontWeight="700"
              fill="#131212"
              textAnchor="middle"
            >
              4
            </text>
          </svg>
          <div className="chart-callouts">
            <div className="co">
              <span className="pin">1</span>
              <span className="when">June 2024</span>
              <div className="what">
                AI adoption <strong>more than doubles in two months</strong> 17% to 37%. ChatGPT Team launches trigger
                enterprise rollouts.
              </div>
            </div>
            <div className="co">
              <span className="pin">2</span>
              <span className="when">January 2025</span>
              <div className="what">
                Monthly spend <strong>doubles overnight</strong> (€175K → €357K) as companies lock in annual plans.
              </div>
            </div>
            <div className="co">
              <span className="pin">3</span>
              <span className="when">February 2026</span>
              <div className="what">
                AI spend <strong>crosses €1M/month</strong> for the first time (€1.02M).
              </div>
            </div>
            <div className="co">
              <span className="pin">4</span>
              <span className="when">May 2026</span>
              <div className="what">
                Monthly AI spend hits <strong>€1.99M</strong>, 46× what it was 28 months earlier.
              </div>
            </div>
          </div>
        </div>
        <div className="stat-bar">
          <div className="row">
            <div />
            <div>2024</div>
            <div>2025</div>
            <div>2026 (Jan–May)</div>
          </div>
          <div className="row">
            <div>Companies using AI</div>
            <div>38.0%</div>
            <div>46.3%</div>
            <div className="strong">52.3%</div>
          </div>
          <div className="row">
            <div>AI share of SaaS spend</div>
            <div>1.7%</div>
            <div>6.2%</div>
            <div className="strong">15.4%</div>
          </div>
          <div className="row">
            <div>Total AI spend</div>
            <div>€1.5M</div>
            <div>€5.7M</div>
            <div className="strong">
              €7.1M <span style={{color: 'var(--grey-500)', fontWeight: 400}}>(in 5 months)</span>
            </div>
          </div>
        </div>
        <div className="cat-insight" style={{marginTop: 32}}>
          In just 5 months of 2026, European companies have already spent more on AI tools (<strong>€7.1M</strong>) than
          in all of 2025 (€5.7M). At current run rate, 2026 AI spend will hit €17M,{' '}
          <strong>a 3× jump in a single year</strong>. AI is no longer a line item. It&apos;s the 3rd-largest software
          spending category, ahead of Comms &amp; Collab.
        </div>
      </div>
    </div>
  </section>
)

export default AiSurgeChart
